<template>
  <div class="koi-preview">
    <img :src="bgImage ? bgImage : ''" alt="" class="big-box-img" />
    <div class="big-body">
      <img :src="tapTopUrl" alt="" class="tap-top" />
      <div class="big-body_content">
        <!-- <div class="koi-title" :style="{ color: titleColor || '#E53935' }">
          购物车锦鲤
        </div> -->
        <div class="prize-content">
          <div class="prize-content-time">
            活动距离开始
            <span class="time-item">30</span>
            天
            <span class="time-item">12</span>
            :
            <span class="time-item">12</span>
            :
            <span class="time-item">12</span>
          </div>
          <div :class="['prize-list', { 'prize-other': prizeList.length < 3 }]">
            <template v-if="prizeList.length == 1">
              <div
                class="prize-item w1"
                v-for="(item, index) in prizeList"
                :key="index"
              >
                <div class="prize-item-img">
                  <img :src="item.logo" alt="" />
                </div>
                <div class="prize-item-title">{{ item.title }}</div>
                <div class="prize-item-num">{{ item.totalAmount }}</div>
              </div>
            </template>
            <template v-if="prizeList.length == 2">
              <div
                class="prize-item w1"
                v-for="(item, index) in prizeList"
                :key="index"
              >
                <div class="prize-item-img">
                  <img :src="item.logo" alt="" />
                </div>
                <div class="prize-item-title">{{ item.title }}</div>
                <div class="prize-item-num">{{ item.totalAmount }}</div>
              </div>
            </template>
            <template v-if="prizeList.length >= 3">
              <div
                class="prize-item w1"
                v-for="(item, index) in prizeList"
                :key="index"
              >
                <div class="prize-item-img">
                  <img :src="item.logo" alt="" />
                </div>
                <div class="prize-item-title">{{ item.title }}</div>
                <div class="prize-item-num">{{ item.totalAmount }}</div>
              </div>
            </template>
          </div>
        </div>
        <div class="main-button">
          <img :src="mainButtonBgImage" alt="" />
          <div :style="{ color: mainButtonTextColor }" class="main-button-text">
            立即抽奖
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shoppingCartKoiPreview",
  props: {
    prizeList: {
      type: Array,
      default: () => [],
    },
    cartItemList: {
      type: Array,
      default: () => [],
    },
    defaultUnlockNum: {
      type: Number,
      default: 1,
    },
    drawLimit: {
      type: Number,
      default: 3,
    },
    mainButtonBgImage: {
      type: String,
      default: "",
    },
    mainButtonTextColor: {
      type: String,
      default: "#fff",
    },
    bgImage: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "#ccc",
    },
  },
  data() {
    return {
      countdownText: "XX天XX时XX分",
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
    };
  },
  computed: {
    displayPrizes() {
      return this.prizeList.slice(0, 3);
    },
    unlockedCount() {
      return Math.min(this.defaultUnlockNum, this.cartItemList.length);
    },
    requiredCount() {
      return this.drawLimit || 3;
    },
  },
  methods: {
    isUnlocked(index) {
      return index < this.defaultUnlockNum;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.koi-preview {
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;
  position: relative;
  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 564px;
    object-fit: cover;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .tap-top {
      margin-top: 5px;
      width: 283px;
      height: 66px;
      object-fit: cover;
    }
    &_content {
      width: 100%;
      margin-top: 8px;
      .koi-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .prize-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 115px auto 0;
        width: 260px;
        padding: 30px 0 0;
        &-time {
          margin-top: 25px;
          display: flex;
          align-items: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #666666;
          line-height: 11px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          .time-item {
            margin: 0 4px;
            background: linear-gradient(33deg, #797162 0%, #373125 100%);
            border-radius: 5px;
            border: 1px solid #ffffff;
            font-weight: 400;
            font-size: 11px;
            color: #ffffff;
            line-height: 11px;
            text-align: center;
            padding: 3px 4px;
          }
        }
        .prize-list {
          width: 270px;
          margin-top: 16px;
          display: flex;
          align-items: center;
          overflow: hidden;
          .prize-item {
            flex-shrink: 0;
            border-radius: 12px;
            margin-right: 8px;
            height: 170px;
            background: #ffffff;
            box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.06);
            border-radius: 12px;
            padding: 5px;
            .prize-item-img {
              position: relative;
              border-radius: 12px;
              img {
                border-radius: 12px;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .prize-item-title {
              text-align: center;
              margin-top: 12px;
              font-weight: 500;
              font-size: 13px;
              color: #1a1a1a;
              line-height: 13px;
            }
            .prize-item-num {
              margin-top: 8px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              line-height: 12px;
              font-style: normal;
              text-transform: none;
              text-align: center;
            }
            &:last-child {
              margin-right: 0;
            }
          }
          .w1 {
            width: 122px;
          }
        }
        .prize-other {
          justify-content: center;
        }
      }
      .main-button {
        margin: 14px auto 0;
        width: 219px;
        height: 35px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        &-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          line-height: 16px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
}
</style>
